module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-01-09-small-536a97373ebadcec911c1197316b7232.png";